import { DropdownOption, dropdownOption } from 'components/dropdown'
import { DateRanges } from 'services/elasticsearch'

export const DateRangesAsDropdownOptions: DropdownOption[] = [
  {key: '3', value: DateRanges.PastWeek, description: 'Last 7 Days'},
  {key: '4', value: DateRanges.LastWeek, description: 'Last Week'},
  {key: '5', value: DateRanges.PastMonth, description: 'Last ~30 Days'},
  {key: '6', value: DateRanges.LastMonth, description: 'Last Month'},
  {key: '7', value: DateRanges.PastSixtyDays, description: 'Last 60 days'},
  {key: '8', value: DateRanges.PastNinetyDay, description: 'Last 90 days'},
]

export const dateRangeDropdownOption = (dateRange: string): DropdownOption => {
  return dropdownOption(dateRange, DateRangesAsDropdownOptions)
}
